import { INSTANCE_SYMBOL } from './render-values.js';
/** The only shape check for the pre-runtime component contract. */
export function isLegacyComponent(value) {
    // The instance exclusion must run before the `.html` probe: on a template
    // instance that property is a getter that invokes the string renderer, so
    // probing it first would string-render the instance (or RT411 on graphs
    // without the string renderer) just to answer a shape check.
    return !!(value &&
        typeof value === 'object' &&
        !value[INSTANCE_SYMBOL] &&
        typeof value.html === 'string');
}
/** Materializes a legacy component for a node part. */
export function materializeLegacyComponent(component, documentObj, domAdapter) {
    const nodes = domAdapter.fragmentFromHtml(component.html, documentObj);
    return {
        nodes,
        mount() {
            component.mount?.(nodes.find((node) => node.nodeType === 1) || nodes[0]);
        },
        cleanup: () => component.unmount?.(),
    };
}
/** Mounts a legacy component directly into a public mount target. */
export function mountLegacyComponent(target, component, domAdapter) {
    const nodes = domAdapter.fragmentFromHtml(component.html, target.ownerDocument || globalThis.document);
    domAdapter.replaceChildren(target, nodes);
    component.mount?.(target.firstElementChild || target.firstChild);
    return () => component.unmount?.();
}
/** Returns legacy markup for the no-DOM renderer. */
export function renderLegacyComponent(component) {
    return component.html;
}
//# sourceMappingURL=render-component-adapter.js.map